import { render, staticRenderFns } from "./BabelRollupConfig.vue?vue&type=template&id=6ddc35e6&"
import script from "./BabelRollupConfig.vue?vue&type=script&lang=ts&"
export * from "./BabelRollupConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports